<template>
  <div class="ApprovalMain">
    <!-- <el-tabs v-model="activeName" type="card" @tab-click="handleClick"> -->
        <!-- <el-tab-pane label="财务审批" name="first"> -->
          <Approval></Approval>
        <!-- </el-tab-pane> -->
        <!-- <el-tab-pane label="审批记录" name="second">
            <Record></Record>
        </el-tab-pane> -->
    <!-- </el-tabs> -->
  </div>
</template>

<script>
import Approval from './Approval'
import Record from './Record'
export default {
    name: "ApprovalMain",
    components: {
        Approval,
        Record
    },
    data() {
      return {
        activeName: 'first'
      };
    },
     methods: {
        handleClick(tab, event) {
            // console.log(tab, event);
        }
    }
}
</script>

<style>

</style>